module.exports = __webpack_public_path__ + "readmeTemplates/blank.38cdd67987afb67a4af89ea02044a00e.md";